// This is a customSanitizer function that is passed to the
// EditableText component to prevent showing errors
export const convertSpacesToUnderscores = (value: string) => value.split(' ').join('_');
